import script from "./AlbumCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumCard.vue?vue&type=script&setup=true&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=64822104&scoped=true&lang=less"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64822104"]])

export default __exports__